export default {"src":"/_next/static/media/BAM.68878807.svg","height":18,"width":18};